/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { DigiticketsConnection } from './DigiticketsConnection';
import {
    DigiticketsConnectionFromJSON,
    DigiticketsConnectionFromJSONTyped,
    DigiticketsConnectionToJSON,
    DigiticketsConnectionToJSONTyped,
} from './DigiticketsConnection';

/**
 * 
 * @export
 * @interface ListDigiticketsConnectionsResponse
 */
export interface ListDigiticketsConnectionsResponse {
    /**
     * 
     * @type {Array<DigiticketsConnection>}
     * @memberof ListDigiticketsConnectionsResponse
     */
    data: Array<DigiticketsConnection>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListDigiticketsConnectionsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListDigiticketsConnectionsResponse interface.
 */
export function instanceOfListDigiticketsConnectionsResponse(value: object): value is ListDigiticketsConnectionsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListDigiticketsConnectionsResponseFromJSON(json: any): ListDigiticketsConnectionsResponse {
    return ListDigiticketsConnectionsResponseFromJSONTyped(json, false);
}

export function ListDigiticketsConnectionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDigiticketsConnectionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(DigiticketsConnectionFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListDigiticketsConnectionsResponseToJSON(json: any): ListDigiticketsConnectionsResponse {
      return ListDigiticketsConnectionsResponseToJSONTyped(json, false);
  }

  export function ListDigiticketsConnectionsResponseToJSONTyped(value?: ListDigiticketsConnectionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(DigiticketsConnectionToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

